
const loginRegistRouter = [
    // 登录页面路由
    {
        path: '/login', 
        name: 'login', 
        meta: { name: '登录'},
        component: () => import('@/views/login/login')
    },
    // 注册页面路由
    {
        path: '/regist', 
        name: 'regist', 
        meta: { name: '注册'},
        component: () => import('@/views/login/regist')
    },
    // 注册完成页面路由
    {
        path: '/registDone', 
        name: 'registDone', 
        meta: { name: '注册成功'},
        component: () => import('@/views/login/registDone')
    },
    // 找回密码-第一步验证身份页面路由
    {
        path: '/resetPwd', 
        name: 'resetPwd', 
        meta: { name: '找回密码'},
        component: () => import('@/views/login/resetPwd')
    },
    // 找回密码-第二步重置密码页面路由
    {
        path: '/resetPwdNext', 
        name: 'resetPwdNext', 
        meta: { name: '重置密码'},
        component: () => import('@/views/login/resetPwdNext')
    },
    // 找回密码-第三步完成页面路由
    {
        path: '/resetPwdDone', 
        name: 'resetPwdDone', 
        meta: { name: '重置成功'},
        component: () => import('@/views/login/resetPwdDone')
    },
]
export default loginRegistRouter


// WEBPACK FOOTER //
// ./src/router/modules/loginRegist.js